// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "carbon-lab." + "5741fb55ef" + "." + chunkId + ".css";
};